import { getAuthInfo } from '@/awsCodes/awsUtils';
import { getAllPayload } from '@/utils/jwt';

/**
 * organizationIdをサーバーから貰ってくる
 */
const getOrganizationId = async (): Promise<string> => {
  try {
    const authInfo = await getAuthInfo();
    if (!authInfo) {
      return 'test';
    }
    const payload: any = getAllPayload(authInfo.idToken);
    return payload['custom:organizationId'];
  } catch (e) {
    return 'test';
  }
};

export { getOrganizationId };
